import type { ServiceOptions } from 'src/types';
import apiClient from 'src/utils/apiClient';

import type {
  AssociateProfile,
  AssociateProfilePlacement,
  AssociateProfilePlacementsResponse,
  AssociateProfileRestrictionsResponse,
} from './types';

function verifyAlias(alias: string) {
  if (!alias) {
    throw new Error('Alias is required');
  }
}
function verifySiteId(siteId: number) {
  if (!siteId) {
    throw new Error('Site ID is required');
  }
}

class AssociateProfileService {
  public async getAssociateProfile(alias: string, siteId: number, options?: ServiceOptions) {
    verifyAlias(alias);
    verifySiteId(siteId);

    return await apiClient.get<AssociateProfile>(`/associateProfile/${alias}/sites/${siteId}`, {
      signal: options?.signal,
    });
  }

  public async getAssociateProfilePlacements(alias: string, siteId: number, options?: ServiceOptions) {
    verifyAlias(alias);
    verifySiteId(siteId);

    return await apiClient.get<AssociateProfilePlacementsResponse>(
      `/associateProfile/${alias}/sites/${siteId}/placements`,
      { signal: options?.signal },
    );
  }

  public async getAssociateProfileRestrictions(alias: string, siteId: number, options?: ServiceOptions) {
    verifyAlias(alias);
    verifySiteId(siteId);

    return await apiClient.get<AssociateProfileRestrictionsResponse>(
      `/associateProfile/${alias}/sites/${siteId}/restrictions`,
      { signal: options?.signal },
    );
  }

  public async getLastPlacementDate(alias: string, siteId: number, options?: ServiceOptions) {
    verifyAlias(alias);
    verifySiteId(siteId);

    return await apiClient.get<string>(`/associateProfile/${alias}/sites/${siteId}/lastPlacementDate`, {
      signal: options?.signal,
    });
  }

  public async getAssociateProfileHistory(alias: string, siteId: number, options?: ServiceOptions) {
    verifyAlias(alias);
    verifySiteId(siteId);

    return await apiClient.get<Array<AssociateProfilePlacement>>(
      `/associateProfile/${alias}/sites/${siteId}/placements/closed`,
      { signal: options?.signal },
    );
  }
}

export default new AssociateProfileService();
